import * as React from 'react';
import { PaletteMode } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import NavbarBack from '../components/club-vip/components/NavbarBack';
import ContactForm from '../components/club-vip/components/ContactForm';
import getLPTheme from '../getLPTheme';
import Copyright from '../auxiliares/Copyright'

export default function ContactFormPage() {
  const [mode] = React.useState<PaletteMode>('dark');  // Cambiar a 'ligh' para que empiece con tema claro.
  const [showCustomTheme] = React.useState(true);
  const LPtheme = createTheme(getLPTheme(mode));
  const defaultTheme = createTheme({ palette: { mode } });

  return (
    <ThemeProvider theme={showCustomTheme ? LPtheme : defaultTheme}>
      <CssBaseline />
      <NavbarBack/>
      <Box sx={{ bgcolor: 'background.default' }}>
        <Divider />
        <ContactForm />
        <Copyright />
      </Box>
    </ThemeProvider>
  );
}
